import { makeStyles } from '@rbx/ui';
import { getCustomMarkdownFontSize } from '@modules/layout/layout/constants/layoutConstants';

const useMarkdownListStyles = makeStyles<{ enableEngineReferenceRevamp: boolean }>()(
  (theme, { enableEngineReferenceRevamp }) => ({
    listContainer: {
      margin: '16px 0',
      padding: '0 0 0 16px',
      fontSize: getCustomMarkdownFontSize(enableEngineReferenceRevamp),
      color: theme.palette.text.secondary,
      'li > div': {
        fontSize: 'inherit',
      },
    },
    orderedList: {
      listStyleType: 'decimal',
      '& ol': {
        listStyleType: 'lower-alpha',
        '& ol': {
          listStyleType: 'lower-roman',
          '& ol': {
            listStyleType: 'upper-alpha',
          },
        },
      },
    },
  }),
);

export default useMarkdownListStyles;
